import { Component, OnInit } from '@angular/core';
import { AppCloseAdvancedSearchAction } from 'app/store/store.actions';
import { Store } from '@ngxs/store';

@Component({
  selector: 'advanced-search-header',
  templateUrl: './advanced-search-header.component.html',
  styleUrls: ['./advanced-search-header.component.scss'],
})
export class AdvancedSearchHeaderComponent implements OnInit {
  closeSignalEmit(): void {
    const action = new AppCloseAdvancedSearchAction();
    this.store.dispatch(action);
  }

  constructor(private store: Store) {}

  ngOnInit(): void {}
}
